<template>
  <div class="redes-sociais">
    <TopBar />
    <h2>Redes Sociais</h2>

    <div class="feeds">
      <!-- Facebook Section -->
      <div class="feed-section">
        <h3>Facebook</h3>
        <a href="https://www.facebook.com/KARATEANAM" target="_blank" class="page-link">
          <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" width="32" />
          <span>KARATE ANAM no Facebook</span>
        </a>

        <div v-if="fbLoading" class="loading">A carregar publicações do Facebook...</div>
        <div v-else-if="fbError" class="error">
          <p>{{ fbError }}</p>
        </div>
        <div v-else-if="fbPosts.length === 0" class="error">
          <p>Nenhuma publicação encontrada.</p>
        </div>
        <div v-else class="feed-embed">
          <div v-for="post in fbPosts" :key="post.id" class="post-card">
            <img v-if="post.full_picture" :src="post.full_picture" :alt="'Post ' + post.id" class="post-image" />
            <p v-if="post.message" class="post-message">{{ truncate(post.message, 200) }}</p>
            <div class="post-footer">
              <span class="post-date">{{ formatDate(post.created_time) }}</span>
              <a :href="post.permalink_url" target="_blank" class="post-link">Ver no Facebook →</a>
            </div>
          </div>
        </div>
      </div>

      <!-- Instagram Section -->
      <div class="feed-section">
        <h3>Instagram</h3>
        <div class="feed-embed">
          <iframe
            src="https://www.instagram.com/anamkarate/embed"
            class="ig-iframe"
            style="border:none;overflow:hidden"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import TopBar from '../components/TopBar.vue';
import Footer from '../components/Footer.vue';

export default {
  name: 'RedesSociais',
  components: { TopBar, Footer },
  data() {
    return {
      fbPosts: [],
      fbLoading: true,
      fbError: null,
    };
  },
  mounted() {
    this.fetchFacebookPosts();
  },
  methods: {
    async fetchFacebookPosts() {
      try {
        const res = await fetch('/api/facebook-posts');
        const data = await res.json();
        if (data.error) {
          this.fbError = data.error;
        } else {
          this.fbPosts = data.data || [];
        }
      } catch (e) {
        this.fbError = 'Erro ao carregar publicações do Facebook.';
      }
      this.fbLoading = false;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('pt-PT', { year: 'numeric', month: 'long', day: 'numeric' });
    },
    truncate(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '…' : text;
    },
  },
};
</script>

<style scoped>
.redes-sociais {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
h2 {
  margin: 2rem 0 1rem;
}
.feeds {
  display: flex;
  gap: 3rem;
  flex-wrap: wrap;
  justify-content: center;
  padding: 1rem 2rem 2rem;
  width: 100%;
  max-width: 1200px;
}
.feed-section {
  flex: 1;
  min-width: 320px;
  max-width: 540px;
  text-align: center;
}
.feed-section h3 {
  font-size: 1.4rem;
  color: #333;
  border-bottom: 2px solid #e53935;
  display: inline-block;
  padding-bottom: 0.3rem;
  margin-bottom: 1rem;
}
.page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
  margin-bottom: 1.5rem;
  padding: 0.8rem 1.5rem;
  background: #1877f2;
  border-radius: 8px;
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  font-size: 1rem;
  transition: background 0.2s;
}
.page-link:hover {
  background: #145db2;
}
.loading {
  color: #888;
  padding: 2rem;
  font-style: italic;
}
.error {
  color: #e53935;
  padding: 1.5rem;
  background: #fff5f5;
  border-radius: 8px;
  border: 1px solid #e53935;
}
.feed-embed {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}
.post-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  overflow: hidden;
  width: 100%;
  max-width: 500px;
  text-align: left;
}
.post-image {
  width: 100%;
  max-height: 350px;
  object-fit: cover;
  display: block;
}
.post-message {
  padding: 0.8rem 1rem;
  color: #333;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
}
.post-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 1rem;
  border-top: 1px solid #eee;
}
.post-date {
  font-size: 0.8rem;
  color: #999;
}
.post-link {
  font-size: 0.85rem;
  color: #1877f2;
  text-decoration: none;
  font-weight: bold;
}
.post-link:hover {
  text-decoration: underline;
}
.ig-iframe {
  width: 500px;
  height: 700px;
  max-width: 100%;
}

@media (max-width: 768px) {
  .feeds {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    padding: 1rem;
  }
  .feed-section {
    min-width: 0;
    max-width: 100%;
    width: 100%;
  }
  .post-card {
    max-width: 100%;
  }
  .ig-iframe {
    width: 100%;
    height: 600px;
  }
}

@media (max-width: 480px) {
  .page-link {
    font-size: 0.9rem;
    padding: 0.6rem 1rem;
  }
  .post-message {
    font-size: 0.9rem;
    padding: 0.6rem 0.8rem;
  }
  .post-footer {
    flex-direction: column;
    gap: 0.3rem;
    align-items: flex-start;
  }
  .ig-iframe {
    height: 500px;
  }
}
</style>
